module.exports = __webpack_public_path__ + "media/images/zalo-e479a55919b2ad62c4760c7be11790d4.svg";